import { getYear } from "date-fns";
import range from "lodash/range";
const Swal = require("sweetalert2");
export const _years = range(1900, getYear(new Date()) + 1, 1);
export const _expyears = range(1900, getYear(new Date()) + 10, 1);
export const _months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const _invalidCSS = {
  border: "1px solid rgb(255, 0, 0)",
  borderRadius: "7px",
};
export const _priority = [
  { title: "Routine", id: 0 },
  { title: "STAT", id: 1 },
];
export const _insRelations = [
  { title: "Self", id: 0 },
  { title: "Spouse", id: 1 },
  { title: "Dependant", id: 2 },
];
export const _billingTypes = [
  { title: "Insurance", id: 0 },
  { title: "No Insurance", id: 1 },
  { title: "Client", id: 2 },
];
export const _ethnicity = [
  { title: "Select Ethnicity", id: 0 },
  { title: "Hispanic", id: 1 },
  { title: "Non-Hispanic", id: 2 },
  { title: "Unknown", id: 3 },
  { title: "Refused", id: 4 },
];
export const _races = [
  { title: "Select Race", id: 0 },
  { title: "Black or African American", id: 1 },
  { title: "White", id: 2 },
  { title: "Hispanic/Latino", id: 3 },
  { title: "Asian", id: 4 },
  { title: "American Indian", id: 5 },
  { title: "Middle Eastern", id: 6 },
  { title: "Alaska Native ", id: 7 },
  { title: "Native Hawaiian and Other Pacific Islander", id: 8 },
  { title: "Preferred Category Not Available", id: 9 },
  { title: "Refused", id: 10 },
  { title: "Unknown", id: 11 },
];
export const _ins = [
  { title: "Aetna", id: "Aetna" },
  { title: "1199 SIEU", id: "1199 SIEU" },
  {
    title: "Affinity by Molina Healthcare",
    id: "Affinity by Molina Healthcare",
  },
  { title: "Empire", id: "Empire" },
  { title: "Empire BC", id: "Empire BC" },
  { title: "Empire BCBS", id: "Empire BCBS" },
  { title: "Fidelis", id: "Fidelis" },
  { title: "GHI", id: "GHI" },
  { title: "Healthfirst", id: "Healthfirst" },
  { title: "Medicaid", id: "Medicaid" },
  { title: "Medicare", id: "Medicare" },
  { title: "Metroplus", id: "Metroplus" },
  { title: "Emblem Health", id: "Emblem Health" },
];
export const _yes_no_unknown = [
  { title: "No", id: 0 },
  { title: "Yes", id: 1 },
  { title: "Unknown", id: 2 },
];
export const _genders = [
  { title: "Select Gender", id: 0 },
  { title: "Male", id: 1 },
  { title: "Female", id: 2 },
];
export const _yes_no = [
  { title: "No", id: 0 },
  { title: "Yes", id: 1 },
];
export const _address = "https://api.naturalyatak.com/";
//export const _address = "http://localhost:5000/";
export function _successMessage() {
  Swal.fire({
    position: "top-end",
    icon: "success",
    title: "Your work has been saved",
    showConfirmButton: false,
    timer: 1500,
  });
}
export const _edit = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-edit fa-margin"
        aria-hidden="true"
        style={{
          color: "blue",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _redPDF = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-file-pdf fa-margin"
        aria-hidden="true"
        style={{
          color: "red",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _print = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-print fa-margin"
        aria-hidden="true"
        style={{
          color: "blue",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _grayPDF = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-file-pdf fa-margin"
        aria-hidden="true"
        style={{
          color: "gray",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _grayUpload = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-upload fa-margin"
        aria-hidden="true"
        style={{
          color: "gray",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _blueUpload = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-upload fa-margin"
        aria-hidden="true"
        style={{
          color: "blue",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _delete = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-trash fa-margin"
        aria-hidden="true"
        style={{
          color: "red",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _setting = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-cog fa-margin"
        aria-hidden="true"
        style={{
          color: "green",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _active = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-toggle-on fa-margin"
        aria-hidden="true"
        style={{
          color: "green",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _deactive = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-toggle-off fa-margin"
        aria-hidden="true"
        style={{
          color: "grey",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _key = (
  <div className="text-center">
    <span>
      <i
        className="fa fa-key fa-margin"
        aria-hidden="true"
        style={{
          color: "green",
          fontSize: "25px",
          marginLeft: "5px",
          cursor: "pointer",
        }}
      ></i>
    </span>
  </div>
);
export const _QCOK = (
  <div className="text-center btn btn-success btn-block">
    QC IS OK/ PERMITED FOR USE
  </div>
);
export const _order = (
  <div className="text-center btn btn-success btn-block">Order</div>
);
export const _notOpened = (
  <div className="text-center btn btn-primary btn-block">Open</div>
);
export const _opened = (
  <div className="text-center btn btn-success btn-block">Opened</div>
);
export const _reprintReceived = (
  <div className="text-center btn btn-success btn-block">
    Print Received Lable
  </div>
);
export const _reprintOpenDate = (
  <div className="text-center btn btn-success btn-block">
    Print Open Date Lable
  </div>
);
export const _QCOK_ChangeDate = (
  <div className="text-center btn btn-success btn-block">Change Open Date</div>
);
export const _needsQC = (
  <div className="text-center btn btn-danger btn-block">NEW LOT/ NEEDS QC</div>
);

export const _b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};
